var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('basic-dialog',_vm._b({attrs:{"title":_vm.title,"primaryButton":"Confirm","secondaryButton":"Cancel","primaryClick":_vm.confirm,"secondaryClick":_vm.cancel}},'basic-dialog',_vm.$attrs,false),[_c('p',{staticClass:"usa-prose mt-3",domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }